<div class="feedback-controls">
  <ng-container *ngFor="let control of feedbackControls; index as i">
    <button
      [ngbTooltip]="iconDisabled ? null : control.label"
      [placement]="selectedMedia ? ETooltipPlacement.Top : ETooltipPlacement.Bottom"
      [disabled]="iconDisabled"
      triggers="hover"
      container="body"
      tooltipClass="custom-tooltip"
      (click)="onSelectFeedback(i, control.name)"
      (keydown.enter)="onSelectFeedback(i, control.name)"
      (mouseenter)="hoveredIndex = i"
      (mouseleave)="hoveredIndex = null"
      (focus)="hoveredIndex = i"
      (blur)="hoveredIndex = null"
      class="feedback-controls_container btn-nostyle"
    >
      <stxt-svg-icon
        [disabled]="iconDisabled"
        [iconConfig]="getIconConfig(control, i)"
        class="feedback-controls_icon"
      ></stxt-svg-icon>
    </button>
  </ng-container>
</div>
